import { render, staticRenderFns } from "./FacebookButton.vue?vue&type=template&id=5469845c&scoped=true&"
import script from "./FacebookButton.vue?vue&type=script&lang=js&"
export * from "./FacebookButton.vue?vue&type=script&lang=js&"
import style0 from "./FacebookButton.vue?vue&type=style&index=0&id=5469845c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469845c",
  null
  
)

export default component.exports